import HeaderMenu from "../sidebar/headermenu";
import { Field, Formik } from "formik";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { API_STATUS } from "../../constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CreateEventApi } from "../../apis/event/create_event_api";
import { EventNoteAllApi } from "../../apis/notification/event_note_all";
import { UpdateEventApi } from "../../apis/event/update_event_api";
import { EditEventApi } from "../../apis/event/edit_event_api";
import GetDate from "../../utils/getdate";
import GetYearDate from "../../utils/getyeardate";

export default function EditEvent() {
    const navigate = useNavigate();
    const [selFiles, setFiles] = useState([]);
    const [ApiStatus, setApiStatus] = useState(API_STATUS);
    const [progress, setProgress] = useState(0);
    const location = useLocation();
    const item = location.state.item;
    const [sdate, setSdate] = useState('');
    const [edate, setEdate] = useState('');
    const [ldate, setLdate] = useState('');

    useEffect(() => {

        const token = sessionStorage.getItem('LOGIN_TOKEN');
        if (token == null) {
            navigate('/login');
        } else {
            setSdate(GetYearDate(item.e_start));
            setEdate(GetYearDate(item.e_end));
            setLdate(GetYearDate(item.e_lastDate));
            // console.log(last.getMonth());
        }

    }, []);

    const addSchema = Yup.object().shape({
        title: Yup.string()
            .min(2, 'Too Short!')
            .required('Enter event title'),
        desc: Yup.string()
            .min(20, 'Enter minimum 20 charectors')
            .required('Enter event  description'),
        startDate: Yup.string().required('Start date required'),
        lastDate: Yup.string().required('Registration date required'),
        state: Yup.string().required('Enter state'),
        city: Yup.string().required('Enter city'),
        address: Yup.string().required('Enter address'),
        pincode: Yup.string().required('Enter pincode'),
        // amount: Yup.string().required('Enter amount')
    });

    useEffect(() => {
        if (ApiStatus.isLoader) {
            setProgress(ApiStatus.process);
        }
        if (!ApiStatus.isError && !ApiStatus.isLoader && ApiStatus.data != null) {
            let res = ApiStatus.data;
            // EventNoteAllApi(res['message']);
            navigate(-1);
        }
    }, [ApiStatus]);

    const submitData = (body) => {

        let formData = new FormData();

        formData.append('eid', item.e_id);
        formData.append('title', body.title);
        formData.append('desc', body.desc);
        formData.append('state', body.state);
        formData.append('city', body.city);
        formData.append('address', body.address);
        formData.append('pincode', body.pincode);
        formData.append('startDate', body.startDate);
        formData.append('endDate', body.endDate);
        formData.append('lastDate', body.lastDate);
        formData.append('amount', body.amount);
        if (selFiles.length > 0) {
            Array.from(selFiles).map(async (file) => {
                formData.append('event_files', file);
            });
            UpdateEventApi(formData, setApiStatus);
        } else {
            EditEventApi(body, setApiStatus);
        }
    }

    return <div id="wrapper">
        <HeaderMenu />
        <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small]">

            <div className="max-w-2xl mx-auto">

                <div className="page__heading py-2 md:py-6 mt-2 md:mt-6">

                    <Link onClick={() => {
                        navigate(-1);
                    }}>
                        <ion-icon name="chevron-back-outline"></ion-icon> Back
                    </Link>

                    <h1> Edit Event </h1>

                </div>

                <div className="mt-6 mb-20 text-sm font-medium text-gray-600 relative dark:text-white/80">

                    <div id="setting_tab" className="bg-white border rounded-xl shadow-sm md:py-12 md:px-20 p-6 overflow-hidden dark:border-slate-700 dark:bg-dark2">
                        <Formik
                            enableReinitialize={true}
                            initialValues={{
                                eid:item.e_id,
                                title: item.e_title,
                                desc: item.e_desc,
                                startDate: sdate,
                                endDate: edate,
                                lastDate: ldate,
                                state: item.e_state,
                                city: item.e_city,
                                address: item.e_address,
                                pincode: item.e_pincode,
                                free: item.e_amount === '0' ? true : false,
                                amount: item.e_amount,
                                email: "",
                                mobile: ""
                            }}
                            validationSchema={addSchema}
                            onSubmit={values => {
                                let body = values;
                                submitData(body);
                            }}
                        >
                            {({ values, errors, touched, isValid, handleChange, setFieldTouched, setFieldValue, handleSubmit }) => (
                                <div>

                                    <div className="space-y-6">

                                        <div className="md:flex items-center gap-10">
                                            <label className="md:w-32 text-right"> Event title </label>
                                            <div className="flex-1 max-md:mt-4">
                                                <Field type="text" name="title" placeholder="" className="w-full" />
                                            </div>
                                        </div>

                                        {
                                            errors.title && touched.title &&
                                            <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.title}</div>
                                        }

                                        {/* <div className="md:flex items-center gap-10">
                                            <label className="md:w-32 text-right"> Select Image </label>
                                            <div className="flex-1 max-md:mt-4">
                                                <input onChange={(e) => {
                                                    setFiles(e.target.files);
                                                }} type="file" placeholder="" name="event_files[]" multiple className="w-full" />
                                            </div>
                                        </div>

                                        <div className="md:flex items-center gap-10 text-blue-500" style={{ justifyContent: 'center' }}>
                                            Note : For good view keep image dimension in 2:1 ration. Ex. 1200 X 600
                                        </div> */}

                                        <div className="md:flex items-start gap-10">
                                            <label className="md:w-32 text-right"> Description </label>
                                            <div className="flex-1 max-md:mt-4">
                                                <Field as="textarea" name="desc" className="w-full" rows="5" placeholder=""></Field>
                                            </div>
                                        </div>
                                        {
                                            errors.desc && touched.desc &&
                                            <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.desc}</div>
                                        }

                                        <div className="md:flex items-center gap-10">
                                            <label className="md:w-32 text-right"> State </label>
                                            <div className="flex-1 max-md:mt-4">
                                                <Field type="text" name="state" placeholder="" className="w-full" />
                                            </div>
                                        </div>
                                        {
                                            errors.state && touched.state &&
                                            <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.state}</div>
                                        }

                                        <div className="md:flex items-center gap-10">
                                            <label className="md:w-32 text-right"> City </label>
                                            <div className="flex-1 max-md:mt-4">
                                                <Field type="text" name="city" placeholder="" className="w-full" />
                                            </div>
                                        </div>
                                        {
                                            errors.city && touched.city &&
                                            <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.city}</div>
                                        }

                                        <div className="md:flex items-start gap-10">
                                            <label className="md:w-32 text-right"> Address </label>
                                            <div className="flex-1 max-md:mt-4">
                                                <Field as="textarea" name="address" className="w-full" rows="5" placeholder=""></Field>
                                            </div>
                                        </div>
                                        {
                                            errors.address && touched.address &&
                                            <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.address}</div>
                                        }

                                        <div className="md:flex items-center gap-10">
                                            <label className="md:w-32 text-right"> Pincode </label>
                                            <div className="flex-1 max-md:mt-4">
                                                <Field type="text" name="pincode" placeholder="" className="w-full" />
                                            </div>
                                        </div>
                                        {
                                            errors.pincode && touched.pincode &&
                                            <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.pincode}</div>
                                        }

                                        <div className="md:flex items-center gap-10">
                                            <label className="md:w-32 text-right"> Start date </label>
                                            <div className="flex-1 max-md:mt-4">
                                                <Field type="date" name="startDate" placeholder="" className="w-full" />
                                            </div>
                                        </div>

                                        {
                                            errors.startDate && touched.startDate &&
                                            <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.startDate}</div>
                                        }

                                        <div className="md:flex items-center gap-10">
                                            <label className="md:w-32 text-right"> End date </label>
                                            <div className="flex-1 max-md:mt-4">
                                                <Field type="date" name="endDate" placeholder="" className="w-full" />
                                            </div>
                                        </div>

                                        <div className="md:flex items-center gap-10">
                                            <label className="md:w-32 text-right"> Last date for registration </label>
                                            <div className="flex-1 max-md:mt-4">
                                                <Field type="date" name="lastDate" placeholder="" className="w-full" />
                                            </div>
                                        </div>
                                        {
                                            errors.startDate && touched.startDate &&
                                            <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.startDate}</div>
                                        }

                                        {/* <div className="md:flex items-center gap-10">
                                            <label className="md:w-32 text-right"> Registration fee </label>
                                            <div className="flex-1 max-md:mt-4">
                                                <Field type="number" name="amount" placeholder="Registration Fees (0 for free)" className="w-full" />
                                            </div>
                                        </div> */}
                                        {
                                            errors.amount && touched.amount &&
                                            <div className='text-red-400' style={{ textAlign: 'center' }}>{errors.amount}</div>
                                        }

                                    </div>

                                    <div className="flex items-center justify-center gap-4 mt-16">
                                        <button
                                            onClick={() => {
                                                if (!isValid) {
                                                    setFieldTouched('title');
                                                    setFieldTouched('desc');
                                                    setFieldTouched('state');
                                                    setFieldTouched('city');
                                                    setFieldTouched('address');
                                                    setFieldTouched('pincode');
                                                    setFieldTouched('startDate');
                                                    setFieldTouched('endDate');
                                                    setFieldTouched('lastDate');
                                                } else {
                                                    handleSubmit();
                                                }
                                            }}
                                            type="button" className="button lg:px-10 bg-primary text-white max-md:flex-1"> Submit <span className="ripple-overlay"></span></button>
                                    </div>

                                </div>
                            )}
                        </Formik>

                    </div>

                    {
                        ApiStatus.isLoader &&
                        <div role="status" style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0, backgroundColor: '#ffffffb8', justifyItems: 'center', alignContent: 'center', padding: 30 }}>

                            {
                                progress < 100 &&
                                <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                    <div class="bg-blue-600 text-xs  h-2.5 text-blue-100 text-center p-0.5 leading-none rounded-full" style={{ width: progress + '%' }}> {progress}</div>
                                </div>
                            }

                            {
                                progress === 100 &&
                                <>
                                    <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
                                    <span class="sr-only">Loading...</span>
                                </>
                            }
                        </div>
                    }



                </div>

            </div>

        </main>
    </div>
}